import { Group, Text } from '@mantine/core';
import { IconUpload } from '@tabler/icons-react';
import React from 'react';

export interface IDropPromptProps {
  title: string;
  description?: React.ReactNode;
  /** Replaces the default upload glyph; pass Dropzone.Accept/Reject/Idle nodes when the icon must react to drag state. */
  icon?: React.ReactNode;
}

/** @registry Idle drag-and-drop invitation (upload glyph + title + helper line) used inside Dropzone bodies and empty drop targets; pair with DropOverlay for the active drag state. */
export const DropPrompt: React.FC<IDropPromptProps> = ({
  title,
  description,
  icon,
}) => (
  <Group justify="center" gap="xl" mih={120} style={{ pointerEvents: 'none' }}>
    {icon ?? <IconUpload size={52} stroke={1.5} />}
    <div>
      <Text size="xl" inline>
        {title}
      </Text>
      {description !== undefined && (
        <Text size="sm" c="dimmed" inline mt="xs">
          {description}
        </Text>
      )}
    </div>
  </Group>
);
